export default __webpack_public_path__ + "static/media/restaurantImg.c4c8f884.PNG";